import { ReservationStatus } from '../apis/models/reservations/res/Reservation';
import strings from '../constants/strings.constants';
import styled from 'styled-components';

export const renderReservationTag = (
  reservedAt: Date,
  status: ReservationStatus,
) => {
  if (status === ReservationStatus.Cancel) {
    return (
      <ReservationStatusTag $color="red">
        {strings.reservationStatusCancel}
      </ReservationStatusTag>
    );
  }

  if (status === ReservationStatus.Receive) {
    return (
      <ReservationStatusTag $color="yellow">
        {strings.reservationStatusRequest}
      </ReservationStatusTag>
    );
  }

  if (status === ReservationStatus.Complete) {
    return (
      <div className="flex gap-1 items-center">
        <ReservationStatusTag $color={'blue'}>
          {`${strings.reservationStatusConfirm}`}
        </ReservationStatusTag>
      </div>
    );
  }
};

const ReservationStatusTag = styled.span<{
  $color: 'blue' | 'yellow' | 'red' | 'gray' | 'green';
}>`
  flex-grow: 0;
  width: initial;
  font-size: 11px;
  font-weight: 500;
  border-radius: 20px;
  padding: 4px 7px;
  color: ${(props) => {
    switch (props.$color) {
      case 'gray':
        return 'rgb(100, 116, 139)';
      case 'blue':
        return '#005CE1';
      case 'yellow':
        return '#d46b08';
      case 'red':
        return '#cf1322';
      case 'green':
        return 'rgb(40, 117, 72)';
      default:
        return '#E17700';
    }
  }};
  background: ${(props) => {
    switch (props.$color) {
      case 'gray':
        return 'rgb(248, 250, 252)';
      case 'blue':
        return '#E5F2FF';
      case 'yellow':
        return '#fff7e6';
      case 'red':
        return '#fff1f0';
      case 'green':
        return 'rgb(244, 252, 247)';

      default:
        return '#E17700';
    }
  }};
`;
